<template>
  <div class="qr-scanner" :class="$store.state.theme" :key="z">
    <MainBackButton />

    <div class="wrapper">
      <div class="subtitle">
        Secured by
        <svgicon
          icon="tuk-word"
          width="45"
          height="45"
          color="#1c37bd"
          :fill="true"
          style="margin-top: -14px; margin-right: 6px"
        ></svgicon
        >&nbsp;
        <i class="fa fa-check has-text-primary" />
        <span class="button is-rounded" @click="chooseSounds">
          <i class="fa fa-ellipsis-v" />
        </span>
      </div>
      <div v-if="showOpeningCamera" class="placeholder">
        <i class="fa fa-camera fa-3x" />
        <p style="margin-top: 16px; font-size: 1.2em">Opening Camera...</p>
      </div>
      <div v-else>
        <qrcode-stream class="qr-reader" @decode="onDecode"></qrcode-stream>
      </div>

      <collapse-transition>
        <div v-if="!showOpeningCamera" class="bottom">
          <div v-if="result" class="notification has-text-left">
            <p style="margin-bottom: 10px">
              <i class="has-text-link" @click="goToURL">{{ result }}</i>
              <i class="fa fa-copy is-pulled-right" @click="copyURL" />
            </p>
            <div class="button is-fullwidth" @click="reset">
              <span>Scan another code</span>
            </div>
          </div>

          <div v-else class="notification is-warning">
            <i class="fa fa-spinner fa-spin fa-sm" />&nbsp;
            {{ $t("qr.detecting") }}
          </div>

          <p v-if="error" class="error has-text-danger">
            <i>{{ error }}</i>
          </p>
        </div>
      </collapse-transition>
    </div>

    <div v-if="isResult" class="centered vcentered goto" @click="goToURL">
      <img src="../assets/logo-round-180.png" alt="tuk icon" />
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import EventBus from "../eventBus";
import { sounds } from "../functions.js";

import VueQrcodeReader from "vue-qrcode-reader";
import MainBackButton from "@/components/MainBackButton.vue";

export default {
  name: "QRCodeScanner",
  components: { MainBackButton },
  data() {
    return {
      z: 0,
      showOpeningCamera: true,
      result: null,
      isResult: false,
      error: null,
      isVisible: false,
      soundIdx: 0,
      unsafeSounds: [
        "unsafe",
        "navigate1",
        "navigate2",
        "mystery_short",
        "mystery_long",
        "parrot",
        "squawk",
        "servo",
      ],
    };
  },
  created() {
    Vue.use(VueQrcodeReader);
  },
  mounted() {
    this.$cookies.set("full_path", this.$route.fullPath);
    this.triggerOpeningCamera();
  },
  methods: {
    triggerOpeningCamera() {
      this.showOpeningCamera = true;
      setTimeout(() => (this.showOpeningCamera = false), 800);
    },
    copyURL() {
      this.$copyText(this.result);
      this.infoToast("Copied URL<br>" + this.result);
    },
    chooseSounds() {
      this.soundIdx += 1;
      if (this.soundIdx >= this.unsafeSounds.length) this.soundIdx = 0;
      this.$store.commit("setQRScannerSound", this.soundIdx);
      this.unsafeSound();
    },
    unsafeSound() {
      sounds(this.unsafeSounds[this.soundIdx]);
    },
    reset() {
      this.z += 1;
      this.$nextTick(() => {
        Object.assign(this.$data, this.$options.data());
        setTimeout(() => (this.showOpeningCamera = false), 800);
      });
    },
    goToURL() {
      if (!this.result.includes(".")) {
        alert("Not a valid URL!");
        this.closeModal();
        return;
      }
      this.console("go to:" + this.result);
      window.location = this.result;
      //   window.open = (this.result, "_blank");
    },
    onDecode(result) {
      this.console("decoded qr code!", result);
      if (!result) {
        EventBus.$emit("DEBUG", "error detecting qr code");
        return;
      }

      // if not safe
      if (!this.isTUKQR(result)) {
        sounds("unsafe");
        this.result = result;
        var red = this.bulmaColor("danger");
        this.$swal({
          // title: "Warning!<br>Not TUK QR Code",
          html: `<div>
          <p style='font-size:1.3em; margin-bottom: 12px'>
          <i class='fa fa-exclamation-triangle' style='color:${red}'></i>
            &nbsp;Not TUK QR Code
          </p>
          <hr>Proceed at your own risk to:<br><br>
          <a style='font-size:1.15em'>${result}</a>
          <hr>
          </div>`,
          showCloseButton: true,
          // showCancelButton: true,
          // cancelButtonText: "Cancel",
          // cancelButtonColor: "#00f",
          confirmButtonText: "Go anyway (unsafe)",
          confirmButtonColor: red,
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            this.goToURL();
          } else if (result.dismiss === "cancel") {
            this.closeModal();
          }
        });
        return;
      }

      // if safe
      sounds("safe"); // play safe QR code detected sound
      EventBus.$emit("DEBUG", "qr decoded: " + result);
      this.result = result;
      this.isResult = true;
      setTimeout(() => this.goToURL(), 1000);
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
      }
    },
  },
};
</script>

<style scoped lang=scss>
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.goto {
  background-color: rgba(39, 243, 243, 0.349);
  padding: 10px;
  border-radius: 10px;
}
.wrapper {
  width: 100vw;
  height: 100vh;
  background-color: #123;
}
.qr-reader {
  height: calc(100vh - 110px);
}
.placeholder {
  position: absolute;
  margin-top: 37vh;
  text-align: center;
  width: 100%;
}
.subtitle {
  text-align: left;
  padding: 16px;
  padding-left: 60px;
  padding-bottom: 10px;
  background-color: white;
  font-weight: 500;
  margin: 0;
  /* color: grey; */
}
.dark .subtitle {
  /* background-color: black; */
  background-color: #1f1b24;
  color: white;
}
.subtitle .button {
  margin-top: -6px;
  margin-right: -10px;
  float: right;
  background-color: rgba(255, 255, 255, 0);
  border: 0px solid white;
}
.dark .subtitle .button {
  color: white;
}
.bottom {
  position: absolute;
  bottom: 0;
}
.notification {
  width: 100vw;
  padding: 18px 10px;
  font-size: 1.2em;
  margin: 0;
  border-radius: 0;
}
.fa-copy {
  color: grey;
}
/* .error {} */
</style>